import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { get } from 'lodash';
import { Breadcrumb } from 'antd';
import { fetchWebhook } from '@api/notificationChannel';
import { StyledWebhooksContainer, StyledWebhookFormWrapper } from '../styled';
import WebhooksForm from '../Edit/WebhooksForm';
import { getModuleLabel } from '../utils';
import AdminOnly from '@src/components/common/AdminOnly';
import { useSelector } from 'react-redux';
import { isAdminRoleSelector } from '@src/store/common/selectors';

const { baseUrl } = window.conviva;

const Webhooks = ({ id }) => {
  const navigate = useNavigate();
  const { module } = window.conviva;
  const isAdminUser = useSelector(isAdminRoleSelector);
  const [hasFetched, setHasFetched] = useState(false);

  const {
    data = null,
    error,
    isFetching,
  }: any = useQuery(
    ['webhook', id],
    () => {
      return fetchWebhook(id).then((response) => {
        return get(response, ['data'], {});
      });
    },
    {
      enabled: !!id && !hasFetched,
      onSuccess: () => setHasFetched(true),
    },
  );

  if (isFetching) {
    return <p>Loading...</p>;
  }

  if (error) {
    return <p>Error: {error.message}</p>;
  }

  const navigateToWebhooks = () => {
    navigate(`${baseUrl}/settings/webhooks`);
  };

  return (
    <StyledWebhooksContainer>
      <Breadcrumb>
        <Breadcrumb.Item onClick={() => navigateToWebhooks()}>
          {`${getModuleLabel(module)} Webhooks `}
          <AdminOnly />
        </Breadcrumb.Item>
        <Breadcrumb.Item>{id ? (isAdminUser ? 'Edit' : 'View') : 'Create'}</Breadcrumb.Item>
      </Breadcrumb>
      <StyledWebhookFormWrapper>
        <WebhooksForm webhook={data ? data.data : {}} />
      </StyledWebhookFormWrapper>
    </StyledWebhooksContainer>
  );
};

export default Webhooks;
